/// <reference path="../objects/constants.ts" />
/// <reference path="../modules/blocks.logger.module.ts"/>
/// <reference path="../objects/interfaces/blocks/iloggerservice.ts" />

module Blocks {

    export class LoggerService implements Blocks.Interfaces.ILoggerService {
        static factoryId: string = "logger";

        error = (message: any, data?: any, title?: string) => {
            if (Constants.debug)
                console.log('error: ' + message);
            //alertify.error(message);
        };
        info = (message: any, data?: any, title?: string) => {
            if (Constants.debug)
                console.log('info: ' + message);
            //alertify.log(message);
        };
        warn = (message: any, data?: any, title?: string) => {
            if (Constants.debug)
                console.log('warn: ' + message);
            //alertify.log(message);
        };
        success = (message: any, data?: any, title?: string) => {
            if (Constants.debug)
                console.log('success: ' + message);
            //alertify.success(message);
        };

        constructor() {

        }
    }

    logger.factory(LoggerService.factoryId, [() => new LoggerService()]);
}

